import { Paragraph, Wrapper, Title } from "./styled";

const PrivacyPolitycy = () => (
  <Wrapper>
    <Title>
      Klauzula informacyjna RODO w zakresie przetwarzania danych osobowych
    </Title>
    <Paragraph>
      <ol>
        <li>
          Administratorem danych osobowych jest: Paweł Kowalewski, ul. Staszica
          58, 16-400 Suwałki. tel: +48783737050, e-mail: biuro@sercefinansow.pl
        </li>
        <li>
          W sprawach dotyczących przetwarzania danych osobowych można
          skontaktować się bezpośrednio z administratorem pod adresem
          e-mail: biuro@sercefinansow.pl lub numerem telefonu: +48783737050.
        </li>
        <li>
          Dane z formularza i korespondencji wykorzystujemy do obsługi zapytania
          oraz udzielenia odpowiedzi. Jeżeli kontakt dotyczy działań przed
          zawarciem umowy podejmowanych na Państwa żądanie lub wykonania umowy,
          podstawą przetwarzania jest art. 6 ust. 1 lit. b RODO. Przy pozostałych
          zapytaniach podstawą jest art. 6 ust. 1 lit. f RODO — nasz prawnie
          uzasadniony interes polegający na prowadzeniu korespondencji
          i odpowiadaniu na skierowane do nas pytania. Jeżeli formularz został
          otwarty z linku oznaczonego parametrami kampanii, wraz ze zgłoszeniem
          możemy otrzymać adres pierwszej odwiedzonej strony, stronę odsyłającą,
          oznaczenia UTM, źródło przejścia oraz identyfikator kliknięcia
          przekazany w adresie strony. Wykorzystujemy je do ustalenia, z jakiego
          źródła pochodzi konkretne zapytanie i oceny skuteczności naszych działań.
        </li>
        <li>
          W Serce Finansów zapytania obsługują Paweł i Justyna Kowalewscy.
          Nie należy przesyłać w formularzu numeru PESEL, skanów dokumentów
          tożsamości, haseł ani danych dotyczących zdrowia. Zakres danych
          potrzebnych do dalszej obsługi kredytowej ustalamy osobno.
        </li>
        <li>
          Przy obsłudze strony i zapytań korzystamy z dostawców usług
          technicznych: Netlify — hosting strony i obsługa formularza
          kontaktowego — oraz LH.pl — obsługa poczty elektronicznej.
          Dostawcy ci przetwarzają dane w zakresie związanym ze świadczeniem
          tych usług. Formularz obejmuje imię, telefon, adres e-mail, temat
          kontaktu, opcjonalną treść wiadomości oraz, jeżeli są dostępne,
          opisane wyżej dane o źródle zgłoszenia.
        </li>
        <li>
          Dane dotyczące zapytania przechowujemy przez czas jego obsługi
          i dalszej korespondencji dotyczącej tej samej sprawy. Długość tego
          okresu zależy od przebiegu kontaktu: udzielenia odpowiedzi,
          zakończenia uzgodnionych działań oraz tego, czy sprawa wymaga
          dalszych wyjaśnień. Po zakończeniu sprawy usuwamy dane, które nie
          są już potrzebne, chyba że istnieje odrębna podstawa ich dalszego
          przechowywania.
          Jeżeli kontakt prowadzi do współpracy, dokumentacja jest przechowywana
          przez czas niezbędny do wykonania umowy oraz, w odpowiednim zakresie,
          przez okres wymagany przepisami prawa (art. 6 ust. 1 lit. c RODO).
          Dane niezbędne do ustalenia, dochodzenia lub obrony konkretnych
          roszczeń mogą być przechowywane do upływu właściwego terminu
          przedawnienia, a w razie trwającego sporu — do jego prawomocnego
          zakończenia. Podstawą jest wtedy nasz prawnie uzasadniony interes
          ochrony praw (art. 6 ust. 1 lit. f RODO). Nie oznacza to
          przechowywania wszystkich zapytań na zapas.
        </li>
        <li>
          Korzystanie z Netlify może wiązać się z przetwarzaniem danych poza
          Europejskim Obszarem Gospodarczym, w tym w Stanach Zjednoczonych.
          Informacje o przetwarzaniu danych i zasadach ich przekazywania
          opisuje dostawca w swojej{" "}
          <a href="https://www.netlify.com/pdf/netlify-dpa.pdf">
            umowie powierzenia przetwarzania danych
          </a>.
          Informacje dotyczące przetwarzania danych w związku z naszymi
          usługami można uzyskać również, kontaktując się z administratorem.
        </li>
        <li>
          Strona korzysta z osadzonej mapy Google oraz czcionek Google Fonts.
          Ich ładowanie powoduje połączenie przeglądarki z serwerami Google
          i przekazanie danych technicznych, takich jak adres IP.
          Informacje o przetwarzaniu tych danych znajdują się w{" "}
          <a href="https://policies.google.com/privacy?hl=pl">
            polityce prywatności Google
          </a>.
        </li>
        <li>
          Na zasadach określonych w RODO przysługuje Państwu prawo dostępu
          do danych, ich sprostowania, usunięcia i ograniczenia przetwarzania.
          W przypadkach przewidzianych w RODO przysługuje również prawo do
          przenoszenia danych. Wobec przetwarzania na podstawie prawnie
          uzasadnionego interesu mogą Państwo wnieść sprzeciw z przyczyn
          związanych ze szczególną sytuacją. Jeżeli dane są przetwarzane
          na podstawie zgody, można ją wycofać w dowolnym momencie bez wpływu
          na zgodność z prawem wcześniejszego przetwarzania.
        </li>
        <li>
          Mają Państwo prawo wniesienia skargi do organu nadzorczego zajmującego
          się ochroną danych osobowych, którym jest Prezes Urzędu Ochrony Danych
          Osobowych, gdy uznają Państwo, iż przetwarzanie Państwa danych
          osobowych narusza przepisy ustawy z dnia 10 maja 2018 r. o ochronie
          danych osobowych (tekst jednolity Dz. U. z 2018 r., poz. 1000) lub
          przepisy Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679
          z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku
          z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu
          takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie
          o ochronie danych) z dnia 27 kwietnia 2016 r. (Dz.Urz.UE.L Nr 119,
          str. 1);
        </li>
        <li>
          Dane udostępnione przez Panią/Pana nie będą podlegały
          zautomatyzowanemu podejmowaniu decyzji oraz profilowaniu;
        </li>
        <li>
          Dane podane w formularzu pochodzą od osób, których dotyczą. Informacje
          o źródle zgłoszenia pochodzą z adresu odwiedzanej strony i informacji
          przekazanej przez przeglądarkę. Pozostają w pamięci otwartej strony
          i są wysyłane do nas dopiero wraz z dobrowolnym wysłaniem formularza.
        </li>
        <li>
          Podanie danych jest dobrowolne, ale wypełnienie pól oznaczonych
          gwiazdką jest konieczne do wysłania formularza. Bez danych kontaktowych
          nie będziemy mogli odpowiedzieć. Można również skontaktować się
          z nami bezpośrednio telefonicznie lub e-mailem.
        </li>
      </ol>
    </Paragraph>
  </Wrapper>
);

export default PrivacyPolitycy;

